import React from 'react'

import { Box, Flex } from '@chakra-ui/react'

import { MobileDevice } from './MobileDisplay.style'

interface MobileMediaDisplayProps {
    media: JSX.Element
    transform?: string | string[]
    color?: string
    stripeColor?: string
    screenBorderColor?: string
    sensorsColor?: string
    buttonsColor?: string
    width?: string | string[]
    height?: string | string[]
    backgroundPosition?: string
    backgroundSize?: string
    objectFit?: string
    top?: string | string[]
    left?: string | string[]
    isPositionRelative?: boolean
}
const MobileDisplay = ({
    media,
    transform = 'scale(0.5)',
    color = 'white',
    stripeColor = 'var(--chakra-colors-gray-100)',
    screenBorderColor = 'var(--chakra-colors-gray-600)',
    sensorsColor = 'var(--chakra-colors-gray-400)',
    buttonsColor = 'var(--chakra-colors-gray-300)',
    width = ['210px'],
    height = ['435px'],
    top = '-218',
    left = '-105',
    isPositionRelative = true,
    ...rest
}: MobileMediaDisplayProps) => (
    <Box position={isPositionRelative ? 'relative' : 'unset'} h={height} w={width}>
        <Flex transform={transform} position="absolute" top={top} left={left}>
            <MobileDevice
                color={color}
                stripeColor={stripeColor}
                screenBorderColor={screenBorderColor}
                sensorsColor={sensorsColor}
                buttonsColor={buttonsColor}
            >
                <div className="device">
                    <div className="device-frame">
                        {React.cloneElement(media, { className: 'device-screen', ...rest })}
                    </div>

                    <div className="device-stripe" />

                    <div className="device-sensors" />

                    <div className="device-btns" />

                    <div className="device-power" />

                    <div className="device-home" />
                </div>
            </MobileDevice>
        </Flex>
    </Box>
)

export default MobileDisplay
